import {
  BASE_PALETTES,
  type BaseThemePalette,
  type ThemeName,
} from '@bn-games/theming';

export type { ThemeName };

export interface Theme extends BaseThemePalette {
  // Checkers shows "C" / "ш" on the menu monogram badge.
  readonly monogram: string;

  // Board square gradients (dark squares = playable in Russian Shashki)
  readonly darkSquareBase: string;
  readonly darkSquareTip: string;
  readonly lightSquareBase: string;
  readonly lightSquareTip: string;

  // King crown
  readonly kingCrownColor: string;
  readonly kingCrownHighlight: string;

  // Mandatory-capture pulse highlight
  readonly mandatoryPulseColor: string;
}

export const MAHOGANY_THEME: Theme = {
  ...BASE_PALETTES.mahogany,
  monogram: 'C',

  darkSquareBase: '#3d1808',
  darkSquareTip: '#1f0c06',
  lightSquareBase: '#d9a062',
  lightSquareTip: '#b07a40',

  kingCrownColor: '#caa05a',
  kingCrownHighlight: '#f4d894',

  mandatoryPulseColor: 'rgba(244, 216, 148, 0.55)',
};

export const PERSIAN_THEME: Theme = {
  ...BASE_PALETTES.persian,
  monogram: 'ش',

  darkSquareBase: '#2a1808',
  darkSquareTip: '#0b2a36',
  lightSquareBase: '#d4a55a',
  lightSquareTip: '#a87c38',

  kingCrownColor: '#d4a55a',
  kingCrownHighlight: '#f0d28a',

  mandatoryPulseColor: 'rgba(58, 166, 176, 0.55)',
};

export const DECO_THEME: Theme = {
  ...BASE_PALETTES.deco,
  monogram: 'C',

  darkSquareBase: '#0a0908',
  darkSquareTip: '#040404',
  lightSquareBase: '#d4b06c',
  lightSquareTip: '#a88848',

  kingCrownColor: '#d4b06c',
  kingCrownHighlight: '#f0d898',

  mandatoryPulseColor: 'rgba(240, 216, 152, 0.5)',
};

export const MONTE_THEME: Theme = {
  ...BASE_PALETTES.monte,
  monogram: 'C',

  darkSquareBase: '#1a0e04',
  darkSquareTip: '#06241a',
  lightSquareBase: '#d4b06c',
  lightSquareTip: '#a88848',

  kingCrownColor: '#d4b06c',
  kingCrownHighlight: '#f0d898',

  mandatoryPulseColor: 'rgba(192, 57, 43, 0.55)',
};

export const THEMES: Record<ThemeName, Theme> = {
  mahogany: MAHOGANY_THEME,
  persian: PERSIAN_THEME,
  deco: DECO_THEME,
  monte: MONTE_THEME,
};
